import { EventName } from '@lit/react';
import { BlocksListItem } from 'blocks-nextjs/blocks-web-components/components/list-item/list-item';
import { BlocksCloseEvent, BlocksOpenEvent, BlocksSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatListItem = createComponent({
  react: React,
  tagName: 'cat-list-item',
  elementClass: BlocksListItem,
  events: {
    onBlSelect: 'bl-select' as EventName<BlocksSelectEvent>,
    onBlFlyoutOpen: 'bl-flyout-open' as EventName<BlocksOpenEvent>,
    onBlFlyoutClose: 'bl-flyout-close' as EventName<BlocksCloseEvent>
  }
});
